import {Component, OnInit} from '@angular/core';
import {doc, Firestore, getDoc} from '@angular/fire/firestore';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ActivatedRoute, Params} from '@angular/router';

@Component({
  selector: 'app-application',
  templateUrl: './application.component.html',
  standalone: false
})
export class ApplicationComponent implements OnInit {
  token: string;

  constructor(private db: Firestore, private snackBar: MatSnackBar, private activatedRoute: ActivatedRoute) {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.token = params['token'];
    });
  }

  ngOnInit(): void {
    getDoc(doc(this.db, 'parametres', 'application')).then((document) => {
      if (this.token === document.get('token')) {
        window.location.href = document.get('lien');
      } else {
        this.message('Impossible de télécharger l\'application');
      }
    });
  }


  message(message, duration = 3000) {
    this.snackBar.open(message, null, {duration});
  }
}
